<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="name"
    track-by="id"
    :options="options"
    :disabled="!editable"
    :allow-empty="false" />
</template>
<script>
export default {
  name: 'CustomerInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      options: []
    };
  },
  beforeCreate() {
    this.axios.get('/admin/customers')
      .then((res) => {
        this.options = res.data.result;
        this.options.forEach((x) => {
          x.name = `${x.name} ${x.surname} (${x.email})`;
        });
        this.options.unshift({ id: 0, name: this.$t('common.None') });
      });
  },
  computed: {
    fieldModelValue: {
      get() {
        if (!this.value) this.$emit('input', 0);
        return (
          this.options.filter((x) => x.id === this.value)
          || this.options.filter((x) => x.id === 0)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.id);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
